export const DashboardSidebar = {
  flow: 'y',
  gap: 'C1',
  IconText: {
    order: '-1',
    fontWeight: '700',
    text: '{{ editor.dashboard.gettingStarted | polyglot }}',
    icon: 'arrow angle down',
    gap: 'Y1',
    align: 'start',
    hide: (el, s) => !s.hideTutorials,
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline'
    },
    Icon: {
      order: 2
    },
    onClick: (ev, el, s) => {
      el.call('setCookie', 'hideTutorialsDashboard', 'false', 365)
      s.toggle('hideTutorials', {
        preventUpdate: ['ChooseProject']
      })
    }
  },
  Title: null,
  Filter: {
    flow: 'y',
    align: 'start',
    gap: 'A',
    position: 'sticky',
    top: 'D1',
    childExtends: {
      extends: ['Button'],
      theme: (el, s) => (s.projectsFilter === el.key ? 'secondary' : 'tertiary'),
      padding: 'Z1 A2',

      onClick: async (ev, el, s) => {
        s.update({
          projectsFilter: el.key
        })
        el.call('setCookie', 'projectsFilter', el.key)
        el.sdk.rootBus.emit('projects:filter', el.key)
      }
    },
    All: {
      text: '{{ editor.dashboard.filter.all | polyglot }}'
    },
    Favorites: {
      text: '{{ editor.dashboard.filter.favorites | polyglot }}'
    },
    Recents: {
      text: '{{ editor.dashboard.filter.recents | polyglot }}'
    },
    New: {
      extends: ['Button'],
      ignoreChildExtends: true,
      theme: null,
      fontWeight: '700',
      text: '{{ editor.dashboard.newProject | polyglot }}',
      isActive: false,
      margin: 'C1 - -',
      background: 'title',
      color: 'title-reversed',
      ':hover': { opacity: '0.85' },
      onClick: async (ev, el, s) => {
        await el.call('openRouterModal', '/settings', {
          key: '/onboarding'
        })
      }
    }
  }
}
